<template>
  <v-alert
    v-if="userStore.isImpersonating"
    dark
    dense
    icon="fa-user-secret"
    tile
    type="warning"
  >
    Impersonating a User
    <template v-slot:append>
      <v-btn
        :x-small="$vuetify.breakpoint.smAndDown"
        :small="$vuetify.breakpoint.mdAndUp"
        outlined
        :to="{ name: 'logout' }"
      >
        Quit
      </v-btn>
    </template>
  </v-alert>
</template>

<script>
import { useUserStore } from "../../store/user";
export default {
  name: "Impersonate",
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
};
</script>
